import React from 'react';
import EmptyShipmentSummary from './components/EmptyShipmentSummary';
import ShipmentSummary from './components/ShipmentSummary';
import StarterKitShipmentSummary from './components/StarterKitShipmentSummary';
import { Container } from './DetailedNextShipmentSummary.styled';
import useDetailedNextShipmentSummary from './useDetailedNextShipmentSummary';
var DetailedNextShipmentSummary = function () {
    var _a = useDetailedNextShipmentSummary(), loading = _a.loading, error = _a.error, subscription = _a.subscription, shipmentItems = _a.shipmentItems, starterKitItem = _a.starterKitItem, shouldShowStarterKitShipmentSummary = _a.shouldShowStarterKitShipmentSummary, shouldShowShipmentSummary = _a.shouldShowShipmentSummary, shouldShowEmptyShipmentSummary = _a.shouldShowEmptyShipmentSummary, content = _a.content;
    var starterKitShipmentSummaryContent = content.starterKitShipmentSummaryContent, shipmentSummaryContent = content.shipmentSummaryContent, emptyShipmentSummaryContent = content.emptyShipmentSummaryContent;
    if (loading || (error === null || error === void 0 ? void 0 : error.networkError)) {
        return React.createElement(Container, { "data-testid": "loading-shipment-summary-section" });
    }
    if (shouldShowEmptyShipmentSummary) {
        return React.createElement(EmptyShipmentSummary, { content: emptyShipmentSummaryContent });
    }
    return (React.createElement(React.Fragment, null,
        shouldShowStarterKitShipmentSummary &&
            starterKitItem &&
            subscription &&
            starterKitShipmentSummaryContent && (React.createElement(StarterKitShipmentSummary, { content: starterKitShipmentSummaryContent, item: starterKitItem, subscription: subscription })),
        shouldShowShipmentSummary && shipmentItems && shipmentSummaryContent && (React.createElement(ShipmentSummary, { items: shipmentItems, content: shipmentSummaryContent }))));
};
export default DetailedNextShipmentSummary;
